export interface Configuration {
  title: string;
  shortName: string;
  logoFileName: string;
  searchSettings: {
    answerType: AnswerType;
    retriever_number: number;
    temperature: number;
    hybrid_search?: boolean;
  };
  examples: ExampleQuestion[];
}

export enum AnswerType {
  LFGA = 'lfqa',
}

export interface ExampleQuestion {
  flagClass: string; // 2-digit value from here https://flagicons.lipis.dev/
  language: string;
  questions: string[];
}

export const CONFIGURATION_NAME = 'configurationName';
export const CHAT_HISTORY = 'chatHistory';

export enum AuthOperation {
  LOGIN = 'login',
  LOGOUT = 'logout'
}
